/*
  PDP stock message renderer.

  Expects on window (set up by product-variant-selector.liquid):
    - getSelectedVariantKey(): string
    - currentProductVariantsStockJSON: { [variantKey]: number }
    - currentProductVariantsStockMessageJSON: { [variantKey]: string }
    - currentProductVariantsOnSaleJSON: { [variantKey]: boolean }

  Expects in the DOM:
    - .instock_msg               — the "IN STOCK" badge
    - .available-soon            — the dynamic message container
    - .ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity — qty input
*/
window.setVariantStockMessage = function setVariantStockMessage() {
  const selectedVariant = getSelectedVariantKey();
  const rawMessage = currentProductVariantsStockMessageJSON[selectedVariant];
  const stockQty = currentProductVariantsStockJSON[selectedVariant] || 0;
  const onSaleMap = typeof currentProductVariantsOnSaleJSON !== "undefined" ? currentProductVariantsOnSaleJSON : {};
  const isSaleVariant = onSaleMap[selectedVariant] === true;
  const qtyInput = $(".ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity").first();
  const selectedQty = parseInt(qtyInput.val()) || 1;
  const leadTimeText = (typeof rawMessage !== "undefined" && rawMessage.trim() !== "") ? rawMessage.trim() : "";
  const fallbackMessage = "Inquire to a Harbour Showroom for Lead Times, <a href='tel:+61296982733'>CALL US +612 9698 2733</a>";
  const addToCartButton = $(".ProductForm__BuyButtons .ProductForm__AddToCart").first();
  const addToCartLabel = addToCartButton.find("span").first();

  if (addToCartButton.length && addToCartLabel.length && !addToCartButton.attr("data-original-label")) {
    addToCartButton.attr("data-original-label", addToCartLabel.text());
  }

  function setAddToCartDisabled(disabled) {
    if (!addToCartButton.length) {
      return;
    }

    if (disabled) {
      addToCartButton.attr("disabled", "disabled");
      addToCartButton.removeAttr("data-action");
      addToCartButton.removeClass("Button--primary").addClass("Button--secondary");
      if (addToCartLabel.length) {
        addToCartLabel.text("OUT OF STOCK");
      }
    } else {
      addToCartButton.removeAttr("disabled");
      addToCartButton.attr("data-action", "add-to-cart");
      if (addToCartButton.attr("data-use-primary-button") === "true") {
        addToCartButton.removeClass("Button--secondary").addClass("Button--primary");
      }
      if (addToCartLabel.length) {
        addToCartLabel.text(addToCartButton.attr("data-original-label") || "ADD TO CART");
      }
    }
  }

  function showInStockBadge() {
    $(".instock_msg").removeClass("hide").text("IN STOCK").css("color", "#056d00");
  }

  function showOutOfStockBadge() {
    $(".instock_msg").removeClass("hide").text("OUT OF STOCK").css("color", "#737373");
  }

  const isOverSaleStock = isSaleVariant && selectedQty > stockQty;

  if (isOverSaleStock) {
    showOutOfStockBadge();
    $(".available-soon").hide().empty();
    setAddToCartDisabled(true);
    return;
  }

  setAddToCartDisabled(false);

  if (stockQty > 0) {
    if (selectedQty > stockQty) {
      $(".instock_msg").addClass("hide");
      const overQty = selectedQty - stockQty;
      if (leadTimeText) {
        $(".available-soon").html("<div class=\"custom_message\"><b>" + stockQty + " In Stock</b> and <b>" + overQty + " on Backorder.</b> " + leadTimeText + "</div>");
      } else {
        $(".available-soon").html("<div class=\"custom_message\"><b>" + stockQty + " In Stock</b> and <b>" + overQty + " on Backorder.</b> " + fallbackMessage + "</div>");
      }
    } else {
      showInStockBadge();
      $(".available-soon").html("<div class=\"custom_message\"><b>" + stockQty + " Units Available</b></div>");
    }
    $(".available-soon").show();
  } else {
    $(".instock_msg").addClass("hide");
    if (leadTimeText) {
      $(".available-soon").html("<div class=\"custom_message\"><b>Estimated Arrival: </b>" + leadTimeText + "</div>");
    } else {
      $(".available-soon").html("<div class=\"custom_message\">" + fallbackMessage + "</div>");
    }
    $(".available-soon").show();
  }
};
